import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import Games from './components/Games.vue'
import GameDetail from './components/GameDetail.vue'

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';

Vue.prototype.$gamedata = { gamedata: require( "../src/assets/gamedata.json" ) };

Vue.use( Router )

const router = new Router(
{
    // mode: 'history',
    base: '/legacy/',
    //If your application is not at your web root, set this property for navigation to correctly append the subdirectory your app is in
    routes: [
    {
        path: '/',
        name: 'games',
        component: Games,
    },
    {
        path: '/:gamename',
        name: 'detail',
        component: GameDetail,
        props: true
    } ]
} )

new Vue(
{
    el: '#app',
    render: h => h( App ),
    router
} )


// WEBPACK FOOTER //
// ./src/main.js